module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/tgs-form/tgs-form.component.css
// module id = ./src/app/shared/components/tgs-form/tgs-form.component.css
// module chunks = main